<template>
  <div class="accordion order-card" role="tablist" id="courseProduct">
    <b-card no-body class="mb-1 noborder-card">
      <b-card-header
        header-tag="header"
        class="p-1 font-weight-bold h6"
        role="tab"
      >
        <order-checkbox
          v-on:addproduct="addProduct"
          :wasChecked="productAlreadyChecked"
          :isChecked="productChecked"
          :product="courseProduct"
          :styles="styles"
          :text="productLabel"
          :dontDisplayProductMandatory="true"
        >
        </order-checkbox>
        <span v-b-toggle.courseProduct>
          <span class="when-closed px-2">
            <i class="fas fa-chevron-down"></i
          ></span>
          <span class="when-open px-2"
            ><i class="fas fa-chevron-up when-open"></i
          ></span>
        </span>
        <span v-if="!productAlreadyChecked" class="ml-2">
          <span v-if="courseProduct.OLD_NETTO">
            <span class="text-danger line-through small px-2">
              {{ commaFormat(courseProduct.OLD_NETTO) }} zł
            </span>
            {{ commaFormat(courseProduct.NETTO) }} zł
            <span class="font-size-11"
              >(Najniższa cena z 30 dni przed obniżką: 179,00)</span
            >
          </span>
          <span v-else> {{ commaFormat(courseProduct.NETTO) }} zł </span>
        </span>
        <span v-else class="ml-2">
          <span> 0 zł </span>
        </span>
      </b-card-header>
      <b-card-body>
        <b-collapse
          id="courseProduct"
          accordion="courseProduct"
          role="tabpanel"
        >
          <b-card-text>
            <div class="mt-1">
              Dlaczego warto? Kurs to
              <strong
                >doskonała baza wiedzy praktycznej, zawsze pod ręką</strong
              >
              , gdyż jest <strong>dostępny wprost z SKP<sup>®</sup></strong
              >, w zakładce Moje konto. Dzięki informacjom zebranym w Kursie
              zdobędziesz solidne podstawy do pracy z programem, oszczędzisz
              czas oraz zyskasz cenne wskazówki i podpowiedzi naszych ekspertów,
              które zagwarantują szybkie rozpoczęcie wykorzystywania potencjału
              SKP<sup>®</sup>. Szkolenie jest adresowane zarówno do Użytkowników
              dopiero rozpoczynających pracę z programem, jak i tych, którzy
              pracują w SKP® już od jakiegoś czasu, ale pragną usystematyzować i
              pogłębić swoją wiedzę.
              <a
                href="https://www.ksiega-podatkowa.pl/kurs-obslugi-programu-skp/o-kursie?ref=MK_opis_zakladka"
                target="_blank"
              >
                Dowiedz się więcej >
              </a>
            </div>
          </b-card-text>
        </b-collapse>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import OrderCheckbox from '../OrderCheckbox';
import NumbersHelper from '../../../../helper/numbersHelper';
import { mapGetters } from 'vuex';

export default {
  name: 'CourseProduct',
  components: { OrderCheckbox },
  props: {
    client: {},
    annualDecl: {},
    products: {},
    styles: {},
    year: {},
    program: {},
  },
  data() {
    return {
      productLabel: 'Certyfikowany Kurs Obsługi SKP<sup>®</sup>',
    };
  },
  created() {
    // if (!this.productAlreadyChecked) {
    //   this.$emit('addproduct', this.courseProduct);
    // }
  },
  computed: {
    ...mapGetters({
      isInCart: 'order/isInCartProducts',
    }),
    courseProduct() {
      return this.products.filter((item) => item.ID === 97)[0];
    },
    productChecked() {
      return this.isInCart(this.courseProduct);
    },
    productAlreadyChecked() {
      return false;
    },
  },
  methods: {
    commaFormat(value) {
      return NumbersHelper.commaFormat(value);
    },
    addProduct(product) {
      this.$emit('addproduct', product);
    },
  },
};
</script>

<style scoped></style>
